import React from "react"

import { FormattedMessage, useIntl } from "react-intl"
import SankeySwitching from "components/CustomerBehavior/Switching/SankeySwitching"
import {
	WALMART_NEGATIVE_COLORS,
	WALMART_POSITIVE_COLORS,
	WALMART_SANKEY_COLORS,
} from "colors"
import { SANKEY_TYPE } from "../../../SankeySwitching/constants"
import { SwitchingSankeyNodes } from "components/CustomerBehavior/Switching/interfaces"
import { mapToSankeyUI } from "./SwitchingSankeyContainer.utils"
import "./SwitchingSankeyContainer.styles.scss"

type SwitchingSankeyContainerProps = {
	data: SwitchingSankeyNodes
	levelName: string
	treeTitle: string
}

const SwitchingSankeyContainer = (props: SwitchingSankeyContainerProps) => {
	const { data: sankeyData, levelName, treeTitle } = props

	const intl = useIntl()

	const { totalSwitching: total } = sankeyData
	const classNameTotal = total >= 0 ? SANKEY_TYPE.PROFITS : SANKEY_TYPE.LOSSES
	const { profit, losses, totalSwitching } = mapToSankeyUI(sankeyData, intl)

	const getDimension = (totalSankey: number) => {
		return (
			(totalSankey * 100) /
			(sankeyData.profits.totalSwitching + sankeyData.losses.totalSwitching)
		)
	}

	const title = `Switching neto en "${levelName}"`

	return (
		<div className="sankey-card">
			<p className="title">
				<FormattedMessage id="phronesis.sankey.switching.title.pretitle" />
				{intl
					.formatMessage({
						id: `phronesis.sankey.switching.title.${treeTitle}`,
					})
					.toLowerCase()}
			</p>
			<div className="sankeys">
				<SankeySwitching
					type={SANKEY_TYPE.LOSSES}
					isVisible={losses.nodes.length > 0}
					links={losses.nodes}
					colorRight={WALMART_SANKEY_COLORS}
					colorLeft={WALMART_NEGATIVE_COLORS}
					totalEarnings={losses.totalSwitching}
					dimension={getDimension(sankeyData.losses.totalSwitching)}
				/>
				<SankeySwitching
					type={SANKEY_TYPE.PROFITS}
					isVisible={profit.nodes.length > 0}
					links={profit.nodes}
					colorRight={WALMART_POSITIVE_COLORS}
					colorLeft={WALMART_SANKEY_COLORS}
					totalEarnings={profit.totalSwitching}
					dimension={getDimension(sankeyData.profits.totalSwitching)}
				/>
			</div>
			<p className={"total"}>
				{title}
				<span className={classNameTotal}>{totalSwitching}</span>
			</p>
		</div>
	)
}

export default SwitchingSankeyContainer
